export const PAYMENT_METHOD_UPDATE = 'pyo_payment_method_update';
